import React from "react";
import "./journal-doc.scss";

const Template = () => {
  return (
    <div className="journal-doc p-6 max-w-4xl mx-auto font-sans text-gray-800 space-y-6">
      <section>
        <h1 className="text-2xl font-bold">Гарчиг бүтнээр</h1>
        <p>Нэгдүгээр зохиогчын овог Нэгдүгээр зохиогчын нэр<sup>1</sup>, Хоёрдугаар зохиогчын овог Хоёрдугаар зохиогчын нэр<sup>2,3</sup>, … Хариуцлагатай зохиогчын овог Хариуцагатай зохиогчын нэр<sup>4</sup></p>
        <p className="text-sm text-gray-600">
          1 Тэнхэм/Тасаг, Байгууллага, Хот, Улс <br />
          (Жишээ нь: Арьс Судлалын Тэнхэм, Анагаах Ухааны Сургууль, АШУҮИС, УБ, Монгол Улс)
        </p>
      </section>

      <section>
        <p><strong>Товч гарчиг:</strong> 10 үгэнд багтаан бичнэ</p>
        <p><strong>Хариуцлагатай зохиогч:</strong> Овог Нэр, Эрдмийн зэрэг</p>
        <p><strong>Хаяг:</strong> Тэнхэм/Тасаг, Байгууллага, Хот, Улс, Зип код</p>
        <p><strong>Утас:</strong> +улсын код – утасны дугаар</p>
        <p><strong>Э-шуудан:</strong> email@example.com</p>
      </section>

      <section>
        <h2 className="text-xl font-semibold">Зорилго</h2>
        <p>Зорилгоо товч бичнэ.</p>
        <h2 className="text-xl font-semibold">Материал арга зүй</h2>
        <p>Судалгаанд хэрэглэсэн аргууд.</p>
        <h2 className="text-xl font-semibold">Үр дүн</h2>
        <p>Үр дүнгээ товч бичих.</p>
        <h2 className="text-xl font-semibold">Дүгнэлт</h2>
        <p>Дүгнэлтээ бичнэ.</p>
        <p><strong>Түлхүүр үг:</strong> MeSH-н загварын дагуу</p>
      </section>

      <section>
        <h2 className="text-xl font-semibold">Үндэслэл</h2>
        <p>Үндэслэл болох тоо баримт, онолын суурь, таамарлал зэргийг бичнэ.</p>
      </section>

      <section>
        <h2 className="text-xl font-semibold">Материал арга зүй</h2>
        <ol className="list-decimal pl-5">
          <li>Арга зүйн дэд гарчиг – Арга зүйтэй холбоотой мэдээлэл</li>
          <li>Арга зүйн дэд гарчиг – Холбогдолтой мэдээлэл</li>
          <li>Статистик боловсруулалт – Статистик аргууд</li>
        </ol>
      </section>

      <section>
        <h2 className="text-xl font-semibold">Үр дүн</h2>
        <ol className="list-decimal pl-5">
          <li>Үр дүнгийн дэд гарчиг</li>
          <li>Үр дүнгийн дэд гарчиг</li>
          <li>Үр дүнгийн дэд гарчиг</li>
        </ol>
      </section>

      <section>
        <h2 className="text-xl font-semibold">Хэлцэмж</h2>
        <p>Судалгааны үр дүнгийн талаар тайлбар, харьцуулалт</p>
      </section>

      <section>
        <h2 className="text-xl font-semibold">Ашиг сонирхолын зөрчил</h2>
        <p>Зохиогчид ашиг сонирхолын зөрчилгүй талаар мэдэгдэнэ.</p>
      </section>

      <section>
        <h2 className="text-xl font-semibold">Талархал</h2>
        <p>Санхүүжилт болон бусад талархал.</p>
      </section>

      <section>
        <h2 className="text-xl font-semibold">Ном зүй</h2>
        <ol className="list-decimal pl-5">
          <li>Номзүй.</li>
          <li>Номзүй.</li>
          <li>Номзүй.</li>
          <li>Номзүй.</li>
          <li>Номзүй.</li>
        </ol>
      </section>

      <section>
        <h2 className="text-xl font-semibold">Хүснэгтүүд</h2>
        <p>Хүснэгт 1. Хүснэгтийн нэр</p>
        <p>Хүснэгтийн бүтэц болон дата оруулна.</p>
        <p>Хүснэгт 2. Хүснэгтийн нэр</p>
        <p>Категори, дата, тайлбар гэх мэт</p>
      </section>

      <section>
        <h2 className="text-xl font-semibold">Зураг</h2>
        <p>Зураг 1. Зургийн товч нэр – тайлбар</p>
        <p>Зураг 2. Зургийн товч нэр – тайлбар</p>
      </section>
    </div>
  );
};

export default Template;
  